import { Component, Input, OnInit } from '@angular/core';
import { ChartOptions, ChartType } from 'chart.js';

@Component({
  selector: 'app-doughnut-chart',
  templateUrl: './doughnut-chart.component.html',
  styleUrls: ['./doughnut-chart.component.scss']
})
export class DoughnutChartComponent implements OnInit {
  @Input() doughnutChartData: number[] = [];
  @Input() doughnutChartLabels = ['Principal & Interest', 'Home Insurance', 'Property Tax', 'HOA Fees'];
  @Input() doughnutChartType: ChartType = 'doughnut';
  @Input() class = 'normal-mortgage'
  @Input() doughnutChartColors= [
    {
      backgroundColor: ['#00BCD5', '#FF9801', '#FFC208', '#3F51B5']
    }
  ];

  @Input() doughnutChartOptions: ChartOptions = {
    responsive: true,
    legend: {
      display:false,
      position: 'center',
      align: 'center',
      labels: {
        boxWidth: 20,
        fontSize: 14,
        padding: 20,
        usePointStyle: true,
        generateLabels: (chart) => {
          const data = chart.data;
          if (data.labels && data.datasets) {
            return data.labels.map((label, i) => {
              const value = Math.round(data.datasets[0].data[i]);
              return {
                text: `${label}: $${value}`,
                fillStyle: data.datasets[0].backgroundColor[i],
                hidden: false,
                lineCap: 'butt',
                lineDash: [],
                lineDashOffset: 0,
                lineJoin: 'miter',
                strokeStyle: 'rgba(0,0,0,0.1)',
                pointStyle: 'circle',
                datasetIndex: 0,
                index: i
              };
            });
          }
          return [];
        }
      }
    },
    tooltips: {
      callbacks: {
        label: (tooltipItem, data) => {
          const dataset = data.datasets[tooltipItem.datasetIndex];
          const value = dataset.data[tooltipItem.index];
          const label = data.labels[tooltipItem.index];
          return `${label}: $${value}`;
        }
      }
    },
  };

  constructor() { }

  ngOnInit() {
  }


}
